import React from 'react';
import './Hotspot.sass';

const Hotspot = ({
                     className,
                     style,
                     index,
                     handleClickHotspot = null,
                     initialVisible = false,
                     clickable = false
                 }) => {
    if (clickable) {
        return (
            <div
                className={`absolute ${
                    initialVisible ? 'opacity-100' : 'opacity-0'
                } overlay-rect ${className || ''}`}
                style={style}
                onClick={() => handleClickHotspot(index)}
            ></div>
        );
    }

    return (
        <div
            className={`absolute ${
                initialVisible ? 'opacity-100' : 'opacity-0'
            } overlay-rect ${className || ''}`}
            style={style}
        ></div>
    );
};

export default Hotspot;
